import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import {
  CreateVariationAttributeValue,
  UpdateVariationAttributeValue,
} from '../models/variation-attribute-value.model';

@Injectable({
  providedIn: 'root',
})
export class VariationAttributeValueService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    value?: string,
    displayName?: string
  ) {
    let params = '';

    if (value) params += `&name=${value}`;
    if (displayName) params += `&displayName=${displayName}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/variation-attribute-values?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/variation-attribute-values/' + id
    );
  }

  getAllDropdown() {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/variation-attribute-values/dropdown`
    );
  }

  getDropdownByAttribute(variationAttributeId: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl +
        `/api/v1/variation-attribute-values/dropdown?variationAttributeId=${variationAttributeId}`
    );
  }

  create(data: CreateVariationAttributeValue) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/variation-attribute-values',
      data
    );
  }

  update(id: string, data: UpdateVariationAttributeValue) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/variation-attribute-values/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/variation-attribute-values/${id}/status`,
      { isActive }
    );
  }
}
